var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 51,
    viewBox: "0 0 56 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25854 46.8763H54.7419V49.3931H1.25854V46.8763Z",
    fill: "#B07816"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5391 0C54.4503 0 56 1.54967 56 3.46094V47.1904C56 49.0419 54.5462 50.5537 52.7178 50.6465L52.5391 50.6514H3.46094L3.28223 50.6465C1.45389 50.5536 0 49.0418 0 47.1904V3.46094C0 1.54967 1.54965 5.06718e-09 3.46094 0H52.5391ZM1.25879 46.876V47.1904C1.25879 48.4067 2.24467 49.3936 3.46094 49.3936H52.5391C53.7553 49.3936 54.7422 48.4067 54.7422 47.1904V46.876H1.25879ZM3.46094 1.25879C2.24466 1.25879 1.25879 2.24467 1.25879 3.46094V45.9326H7.0791V21.9648L33.0342 14.9883V14.9434L48.4492 25.1689V45.9326H54.7422V3.46094C54.7422 2.24467 53.7553 1.25879 52.5391 1.25879H3.46094ZM9.28125 23.6533V45.9326H11.1738C11.1804 45.7573 11.1879 45.5813 11.1943 45.4043C11.276 43.1703 11.3467 40.935 11.4404 38.6963C11.4541 38.3095 11.5051 37.9213 11.5986 37.5391C11.8567 36.4403 12.6582 35.3858 13.7373 34.9268C14.4428 34.6143 15.2083 34.5921 15.873 34.7275C16.1221 34.7772 16.3566 34.8461 16.5889 34.9297C16.8572 35.0262 16.8311 35.5504 16.4443 35.542C16.2263 35.5198 16.0158 35.514 15.8066 35.5254C15.243 35.5546 14.7261 35.7289 14.3496 36.0254C13.7699 36.4783 13.5528 37.1978 13.4473 37.9199C13.4102 38.1727 13.3995 38.4341 13.4131 38.6963C13.5069 40.935 13.5785 43.1703 13.6602 45.4043C13.6666 45.5813 13.6731 45.7573 13.6797 45.9326H33.0342V17.2695L9.28125 23.6533Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7419 31.4605V33.8201L33.0616 22.1022L1.25854 31.1459V28.9437L33.3206 19.7399L54.7419 31.4605Z",
    fill: "#B07816"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.efcd4c87cf8b4adce75aaced1ad68342.svg";
export { ForwardRef as ReactComponent };